// extracted by mini-css-extract-plugin
export default {"editorWrapper":"DjvJ1P2F"};